$(function () {
    var $body = $('body');
    window.currentTab = 0;
    window.hasInvalidValue = false;
    window.formGa = {
        second: false,
        third: false,
        final: false
    };
    window.formAge = 0;

    // only works on Apply now form page
    if (!$body.hasClass('page-type--applynowform')) return;

    const $form = $('#apply-now-form');
    const form = document.querySelector('#apply-now-form');
    const $next = $('.apply-now__next');
    const $back = $('.apply-now__back');
    const $save = $('.apply-now__save');
    const $submit = $('.apply-now__submit');
    const tabs = [
        document.querySelector('[data-step="0"]'),
        document.querySelector('[data-step="1"]'),
        document.querySelector('[data-step="2"]'),
        document.querySelector('[data-step="3"]'),
    ];

    const $firstName = $('#FirstName');
    const $preferredName = $('#PreferredName');

    const $whatAreYouInterested = $('#WhatAreYouInterested-Another');
    const $courseAreas = $('#UserCourseAreas');
    const $course = $('#Course');
    const $userSelectedCourse = $('#UserSelectedCourse');

    const $dobDay = $('#dob-day');
    const $dobMonth = $('#dob-month');
    const $dobYear = $('#dob-year');
    const pgDetails = $('#parent-guardian-details');

    const $postalHomeYes = $('#IsPostalAddressHome-Yes');
    const $postalHomeNo = $('#IsPostalAddressHome-No');
    const $differentPostAddressFields = $('#different-postal-address');
    const $studyHomeAddressYes = $('#IsStudyAddressHome-Yes');
    const $studyHomeAddressNo = $('#IsStudyAddressHome-No');
    const $differentStudyAddressFields = $('#different-study-address');

    const $higherEducationYes = $('#CompletedHigherEducation-Yes');
    const $higherEducationNo = $('#CompletedHigherEducation-No');
    const $higherEducationFields = $('.higher-education-details');

    const $visaFieldWrapper = $('.visa-field-wrapper');
    const $residencyStatusRadios = $('[name="ResidencyStatus"]');

    const $countryOfBirthRadios = $('[name="CountryOfBirth"]');
    const $otherCountryWrapper = $('.other-birth-country');
    const $otherCountryField = $('#OtherCountryOfBirth');
    const $arrivalField = $('#ArrivalYear');

    const $originRadios = $('[name="IsAboriginalAndTorresStraitIslander"]');
    const $originSpecifyWrapper = $('.origin-specify-radios');
    const $originSpecifyRadios = $('[name="Origin]');

    const $otherLanguageRadios = $('[name="OtherLanguage"]');
    const $otherLanguageWrapper = $('.other-spoken-language');
    const $otherLanguageSpecify = $('#MostSpokenLanguage');

    const $additionalSupportRadios = $('[name="HasDisability"');
    const $additionalSupportWrapper = $('.additional-support-options');
    const $additionalSupportOtherWrapper = $('.additional-support-other');
    const $additionalSupportOptions = $('[name="DisabilityCondition"]');
    const $additionalSupportOtherField = $('#OtherDisabilityCondition');

    const $technologyRadios = $('[name="DigitalTechnology"]');
    const $otherTechnologyWrapper = $('.other-digital-technology');
    const $otherTechnologyField = $('#OtherDigitalTechnology');

    const $priorLearningRadios = $('[name="ApplyForRecognitionOfPriorLearning"]');
    const $previousWorkWrapper = $('.previous-work-info');
    const $previousWorkField = $('#PreviousWork');

    const $completedEducation = $('[name="CompletedHigherEducation"]');
    const $educationDetails = $('.higher-education-details');

    const $secondarySchoolEnrolled = $('[name="EnrolledInSecondarySchool"]');
    const $enrollmentNote = $('.enrollment-note');

    const gteCheckboxes = document.querySelectorAll('.gte-one');

    function handleCourseListOptions(value, resetSelection) {
        const parsedValue = Number.parseInt(value, 10);
        if (parsedValue !== -1) {
            window.allCourseOptions = window.allCourseOptions || $userSelectedCourse.find('option');
            if (window.allCourseOptions.length) {
                let newCourseOptions = '';
                for (let i = 0; i < window.allCourseOptions.length; i += 1) {
                    const opt = window.allCourseOptions[i];
                    const area = opt.dataset.area ? Number.parseInt(opt.dataset.area, 10) : 0;
                    if (area === parsedValue || area === 0 || i === 0) {
                        newCourseOptions += opt.outerHTML;
                    }
                    if (resetSelection) {
                        $userSelectedCourse.val('');
                    }
                }
                if (newCourseOptions) {
                    $userSelectedCourse.html(newCourseOptions);
                }
            }
        }
    }

    function setHiddenCourseField(value) {
        if (value) {
            // Only want course code
            $course.val(value);

            // const option = $userSelectedCourse.find(`option[value="${value}"]`);
            // $course.val(option.text().trim());
        }
    }

    handleCourseListOptions($courseAreas.val(), false);
    setHiddenCourseField($userSelectedCourse.val());

    $courseAreas.change(function (e) {
        handleCourseListOptions(e.target.value, true);
    });

    $userSelectedCourse.change(function (e) {
        setHiddenCourseField(e.target.value);
    });

    function validateField(field, invalid) {
        const fieldName = field.name;
        const parent = field.closest('.required-multi-choice-question') || field.closest('.swtf-control') || field.parentElement;
        const fieldLabel = parent.querySelector('label');
        const validation = parent.querySelector(`[data-valmsg-for="${fieldName}"]`);

        if (invalid || !field.checkValidity() || field.value === '-1') {
            if (field.required && validation) {
                field.classList.add('input-validation-error');
                validation.classList.add('field-validation-error');

                if (field.validationMessage) {
                    validation.innerText = field.validationMessage;
                } else {
                    if (field.dataset.valRequired) {
                        validation.innerText = field.dataset.valRequired;
                    } else {
                        validation.innerText = `The ${fieldLabel.innerText} is required.`;
                    }
                }
                window.hasInvalidValue = true;
            }
        } else {
            field.classList.remove('input-validation-error');
            if (validation) {
                validation.classList.remove('field-validation-error');
                validation.innerText = '';
            }
        }
    }

    function toggleDateRelatedFields() {
        const $dobNote = $('.dob-note');
        const $notEnrolledInSecondary = $('#EnrolledInSecondarySchool-No');

        if ($dobNote) {
            if (window.formAge < 17) {
                $dobNote.addClass('show');
            } else {
                $dobNote.removeClass('show');
            }
        }
        if ($notEnrolledInSecondary) {
            if (window.formAge >= 19) {
                $notEnrolledInSecondary.prop('checked', true);
            }
            if (window.formAge < 17) {
                if ($notEnrolledInSecondary.checked) {
                    $enrollmentNote.addClass('show');
                } else {
                    $enrollmentNote.addClass('hide');
                }
            }
        }
    };

    function dobValidation() {
        const $dobDay = $('#dob-day');
        const $dobMonth = $('#dob-month');
        const $dobYear = $('#dob-year');
        const $dobField = $('#DateOfBirth');
        const $pgDetails = $('#parent-guardian-details');
        const $pgHeading = $('.parent-guardian-details--heading');

        const day = $dobDay.val();
        const month = $dobMonth.val();
        const year = $dobYear.val();
    
        if (day && month && year) {
            const dateString = year + '-' + month + '-' + day;
            const now = dayjs();
            const date = dayjs(dateString, 'YYYY-MM-DD');

            if (date.isValid()) {
                $dobField.val(dateString);
                const $childFields = $pgDetails.find('input');

                if (now.subtract(18, 'year').isAfter(date)) {
                    if ($childFields.length) {
                        $childFields.prop('required', false);
                    }
                    $pgDetails.hide();
                    $pgHeading.hide();
                } else {
                    if ($childFields.length) {
                        $childFields.prop('required', true);
                    }
                    $pgDetails.show();
                    $pgHeading.show();
                }
                window.formAge = now.diff(date, 'year');
            }
            toggleDateRelatedFields();
        }
    }

    function initFields() {
        if ($firstName && $preferredName) {
            const prefNameNote = document.querySelector('.pref-name-note');
            $firstName.on('blur', (e) => {
                $preferredName.val(e.target.value);
            });
            if (prefNameNote) {
                $preferredName.on('change', (e) => {
                    if (e.target.value && e.target.value !== $firstName.val()) {
                        prefNameNote.classList.add('show');
                    } else {
                        prefNameNote.classList.remove('show');
                    }
                });
            }
        }
        if ($postalHomeNo && $postalHomeYes && $differentPostAddressFields) {
            if (!$postalHomeYes.checked) {
                $differentPostAddressFields.hide();
            }
            $postalHomeNo.on('change', (e) => {
                if (e.target.checked) {
                    $differentPostAddressFields.show();
                    const postalInputs = $differentPostAddressFields.find('input,select');
                    postalInputs.prop('required', true);
                }
            });
            $postalHomeYes.on('change', (e) => {
                if (e.target.checked) {
                    $differentPostAddressFields.hide();
                    const postalInputs = $differentPostAddressFields.find('input,select');
                    postalInputs.prop('required', false);
                }
            });
        }
        if ($studyHomeAddressNo && $studyHomeAddressYes && $differentStudyAddressFields) {
            if (!$studyHomeAddressYes.checked) {
                $differentStudyAddressFields.hide();
            }
            $studyHomeAddressNo.on('change', (e) => {
                if (e.target.checked) {
                    $differentStudyAddressFields.show();
                    const postalInputs = $differentStudyAddressFields.find('input,select');
                    postalInputs.prop('required', true);
                }
            });
            $studyHomeAddressYes.on('change', (e) => {
                if (e.target.checked) {
                    $differentStudyAddressFields.hide();
                    const postalInputs = $differentStudyAddressFields.find('input,select');
                    postalInputs.prop('required', false);
                }
            });
        }
        if ($higherEducationNo && $higherEducationYes && $higherEducationFields) {
            if (!$higherEducationYes.checked) {
                $higherEducationFields.hide();
            }
            $higherEducationNo.on('change', (e) => {
                if (e.target.checked) {
                    $higherEducationFields.show();
                }
            });
            $higherEducationYes.on('change', (e) => {
                if (e.target.checked) {
                    $higherEducationFields.hide();
                }
            });
        }
        if ($dobDay && $dobMonth && $dobYear) {
            $dobDay.on('change', () => {
                dobValidation();
            });
            $dobMonth.on('change', () => {
                dobValidation();
            });
            $dobYear.on('change', () => {
                dobValidation();
            });
        }
        if ($residencyStatusRadios && $visaFieldWrapper) {
            const $toggleField = $residencyStatusRadios.filter('[value="Permanent humanitarian visa"]');
            const $toggleFieldTwo = $residencyStatusRadios.filter('[value="Temporary entry permit or diplomat"]');
            if (!(($toggleField && $toggleField.checked) || ($toggleFieldTwo && $toggleFieldTwo.checked))) {
                $visaFieldWrapper.hide();
            }
            $residencyStatusRadios.on('change', (e) => {
                if ((e.target.value === 'Permanent humanitarian visa' && e.target.checked) || (e.target.value === 'Temporary entry permit or diplomat' && e.target.checked)) {
                    $visaFieldWrapper.show();
                } else {
                    $visaFieldWrapper.hide();
                }
            })
        }
        if ($countryOfBirthRadios && $otherCountryField && $arrivalField && $otherCountryWrapper) {
            const $toggleField = $countryOfBirthRadios.filter('[value="Other"]');
            if (!$toggleField || !$toggleField.checked) {
                $otherCountryWrapper.hide();
            }
            $countryOfBirthRadios.on('change', (e) => {
                if (e.target.value === 'Australia' && e.target.checked) {
                    $otherCountryWrapper.hide();
                    $otherCountryField.prop('required', false);
                    $arrivalField.prop('required', false);
                } else {
                    $otherCountryWrapper.show();
                    $otherCountryField.prop('required', true);
                    $arrivalField.prop('required', true);
                }
            })
        }
        if ($originRadios && $originSpecifyRadios && $originSpecifyWrapper) {
            const $toggleField = $originRadios.filter('[value="No"]');
            if (!$toggleField || !$toggleField.checked) {
                $originSpecifyWrapper.hide();
            }
            $originRadios.on('change', (e) => {
                if (e.target.value === 'No' && e.target.checked) {
                    $originSpecifyWrapper.hide();
                    $originSpecifyRadios.prop('required', false);
                } else {
                    $originSpecifyWrapper.show();
                    $originSpecifyRadios.prop('required', true);
                }
            })
        }
        if ($otherLanguageRadios && $otherLanguageSpecify && $otherLanguageWrapper) {
            const $toggleField = $otherLanguageRadios.filter('[value="No"]');
            if (!$toggleField || !$toggleField.checked) {
                $otherLanguageWrapper.hide();
            }
            $otherLanguageRadios.on('change', (e) => {
                if (e.target.value === 'No' && e.target.checked) {
                    $otherLanguageWrapper.hide();
                    $otherLanguageSpecify.prop('required', false);
                } else {
                    $otherLanguageWrapper.show();
                    $otherLanguageSpecify.prop('required', true);
                }
            })
        }
        if ($additionalSupportRadios && $additionalSupportWrapper && $additionalSupportOtherWrapper && $additionalSupportOptions && $additionalSupportOtherField) {
            const $toggleField = $additionalSupportRadios.filter('[value="No"]');
            if (!$toggleField || !$toggleField.checked) {
                $additionalSupportWrapper.hide();
            }
            const $nextToggleField = $additionalSupportOptions.filter('[value="Other, please specify"]');
            if (!$nextToggleField || !$nextToggleField.checked) {
                $additionalSupportOtherWrapper.hide();
            }
            $additionalSupportRadios.on('change', (e) => {
                if (e.target.value === 'No' && e.target.checked) {
                    $additionalSupportWrapper.hide();
                    $additionalSupportOtherWrapper.hide();
                    $additionalSupportOptions.prop('required', false);
                    $additionalSupportOtherField.prop('required', false);
                } else {
                    $additionalSupportWrapper.show();
                    $additionalSupportOptions.prop('required', true);
                }
            });
            $additionalSupportOptions.on('change', (e) => {
                if (e.target.value === 'Other, please specify') {
                    if (e.target.checked) {
                        $additionalSupportOtherWrapper.show();
                        $additionalSupportOtherField.prop('required', true);
                    } else {
                        $additionalSupportOtherWrapper.hide();
                        $additionalSupportOtherField.prop('required', false);
                    }
                }
            });
        }
        if ($technologyRadios && $otherTechnologyWrapper && $otherTechnologyField) {
            const $toggleField = $technologyRadios.filter('[value="Other"]');
            if (!$toggleField || !$toggleField.checked) {
                $otherTechnologyWrapper.hide();
            }
            $otherTechnologyWrapper.hide();
            $technologyRadios.on('change', (e) => {
                if (e.target.value === 'Other') {
                    if (e.target.checked) {
                        $otherTechnologyWrapper.show();
                        $otherTechnologyField.prop('required', true);
                    } else {
                        $otherTechnologyWrapper.hide();
                        $otherTechnologyField.prop('required', false);
                    }
                }
            })
        }
        if ($priorLearningRadios && $previousWorkWrapper && $previousWorkField) {
            const $toggleField = $priorLearningRadios.filter('[value="No"]');
            if (!$toggleField || !$toggleField.checked) {
                $previousWorkWrapper.hide();
            }
            $priorLearningRadios.on('change', (e) => {
                if (e.target.value === 'Yes' && e.target.checked) {
                    $previousWorkWrapper.show();
                    $previousWorkField.prop('required', true);
                } else {
                    $previousWorkWrapper.hide();
                    $previousWorkField.prop('required', false);
                }
            })
        }
        if ($completedEducation && $educationDetails) {
            const $toggleField = $completedEducation.filter('[value="No"]');
            if ($toggleField && $toggleField.checked) {
                $educationDetails.hide();
            }
            $completedEducation.on('change', (e) => {
                if (e.target.value === 'No' && e.target.checked) {
                    $educationDetails.hide();
                } else {
                    $educationDetails.show();
                }
            });
        }
        if ($secondarySchoolEnrolled && $enrollmentNote) {
            const $toggleField = $secondarySchoolEnrolled.filter('[value="No"]');
            if ($toggleField && $toggleField.checked && window.formAge < 17) {
                $enrollmentNote.addClass('show');
            }
            $secondarySchoolEnrolled.on('change', (e) => {
                if (e.target.value === 'No' && e.target.checked && window.formAge < 17) {
                    $enrollmentNote.addClass('show');
                } else {
                    $enrollmentNote.removeClass('show');
                }
            });
        }
        if (gteCheckboxes.length) {
            for (let i = 0; i < gteCheckboxes.length; i += 1) {
                const group = gteCheckboxes[i];
                const options = group.querySelectorAll('input[type="checkbox"]');
                if (options.length) {
                    for (let o = 0; o < options.length; o += 1) {
                        options[o].addEventListener('change', (e) => {
                            if (e.target.checked) {
                                const otherOptions = group.querySelectorAll(`input[type="checkbox"]:not([value="${e.target.value}"])`);
                                if (otherOptions.length) {
                                    for (let oo = 0; oo < otherOptions.length; oo += 1) {
                                        otherOptions[oo].required = false;
                                    }
                                }
                            } else {
                                for (let oo = 0; oo < otherOptions.length; oo += 1) {
                                    options[oo].required = true;
                                }
                            }
                        });
                    }
                }
            }
        }

        const allInputs = form.querySelectorAll('input,textarea,select');
        for (let i = 0; i < allInputs.length; i += 1) {
            const input = allInputs[i];
            if (input.dataset.valRequired) {
                input.required = 'required';
            }
            input.addEventListener('invalid', (e) => {
                validateField(e.target, true);
            });
            input.addEventListener('blur', (e) => {
                validateField(e.target, false);
            });
        }
        dobValidation();
    }

    function initAutocomplete() {
        const addressField = document.querySelector("#Address");
        const postalAddressField = document.querySelector('#PostalAddress');
        const studyAddressField = document.querySelector('#StudyAddress');
        // Create the autocomplete object, restricting the search predictions to
        // addresses in Australia.
        autocomplete = new google.maps.places.Autocomplete(addressField, {
            componentRestrictions: { country: ["au"] },
            fields: ["address_components"],
            types: ["address"],
        });
        autocomplete.addListener("place_changed", () => fillInAddress());
        autocompletePostal = new google.maps.places.Autocomplete(postalAddressField, {
            componentRestrictions: { country: ["au"] },
            fields: ["address_components"],
            types: ["address"],
        });
        autocompletePostal.addListener("place_changed", () => fillInAddress('postal'));
        autocompleteStudy = new google.maps.places.Autocomplete(studyAddressField, {
            componentRestrictions: { country: ["au"] },
            fields: ["address_components"],
            types: ["address"],
        });
        autocompleteStudy.addListener("place_changed", () => fillInAddress('study'));
    }

    function fillInAddress(type) {
        let place = null;
        let prefix = '';
        const newAddressObject = {
            address: '',
            city: '',
            postcode: '',
            state: ''
        };
        if (type === 'postal') {
            place = autocompletePostal.getPlace();
            prefix = 'Postal';
        } else if (type === 'study') {
            place = autocompleteStudy.getPlace();
            prefix = 'Study';
        } else {
            place = autocomplete.getPlace();
        }

        if (place) {
            for (const component of place.address_components) {
                const componentType = component.types[0];
            
                switch (componentType) {
                    case 'subpremise': {
                        newAddressObject.address = `${component.long_name} / `;
                        break;
                    }
                    case 'street_number': {
                        newAddressObject.address += `${component.long_name} `;
                        break;
                    }
                    case 'route': {
                        newAddressObject.address += `${component.long_name}`;
                        break;
                    }
                    case 'postal_code': {
                        newAddressObject.postcode = component.long_name;
                        break;
                    }
                    case 'locality': {
                        newAddressObject.city = component.long_name;
                        break;
                    }
                    case 'administrative_area_level_1': {
                        newAddressObject.state = component.long_name;
                        break;
                    }
                }
            }
            const addressField = document.querySelector(`#${prefix}Address`);
            const cityField = document.querySelector(`#${prefix}Town`);
            const postcodeField = document.querySelector(`#${prefix}Postcode`);
            const stateField = document.querySelector(`#${prefix}State`);

            stateField.focus();

            if (addressField && newAddressObject.address) {
                addressField.value = newAddressObject.address;
            }
            if (cityField && newAddressObject.city) {
                cityField.value = newAddressObject.city;
            }
            if (postcodeField && newAddressObject.postcode) {
                postcodeField.value = newAddressObject.postcode;
            }
            if (stateField && newAddressObject.state) {
                stateField.value = newAddressObject.state;
            }
        }
    }

    // Button Listeners
    $next.on('click', function (e) {
        e.preventDefault();

        const currentTab = tabs[window.currentTab];
        const currentTabInputs = currentTab.querySelectorAll('input,textarea,select');

        if (currentTabInputs.length) {
            window.hasInvalidValue = false;
            for (let i = 0; i < currentTabInputs.length; i += 1) {
                validateField(currentTabInputs[i], false);
            }
        }

        if (!window.hasInvalidValue) {
            tabs[window.currentTab].classList.remove('active');
            window.currentTab += 1;
            tabs[window.currentTab].classList.add('active');

            if (window.currentTab > 0) {
                $back.show();
            }
            if (window.currentTab === 3) {
                $next.hide();
                $submit.show();
            }

            if (window.currentTab === 2 && !window.formGa.second) {
                window.formGa.second = true;
                gtag && gtag('event', 'Proceed to second step', {
                    event_category: 'Apply Now Form',
                    event_label: 'Next'
                });
            }
            if (window.currentTab === 3 && !window.formGa.third) {
                window.formGa.third = true;
                gtag && gtag('event', 'Proceed to third step', {
                    event_category: 'Apply Now Form',
                    event_label: 'Next'
                });
            }
            if (window.currentTab === 3 && !window.formGa.final) {
                window.formGa.final = true;
                gtag && gtag('event', 'Proceed to final step', {
                    event_category: 'Apply Now Form',
                    event_label: 'Next'
                });
            }

            form.scrollIntoView({
                behavior: 'smooth'
            });
        } else {
            const currentTabErrors = currentTab.querySelectorAll('input.input-validation-error, select.input-validation-error, textarea.input-validation-error');
            if (currentTabErrors.length) {
                currentTabErrors[0].parentElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
    });

    $back.on('click', function (e) {
        e.preventDefault();

        tabs[window.currentTab].classList.remove('active');
        window.currentTab -= 1;
        tabs[window.currentTab].classList.add('active');

        form.scrollIntoView({
            behavior: 'smooth'
        });

        if (window.currentTab === 0) {
            $back.hide();
        }
        if (window.currentTab < 3) {
            $next.show();
            $submit.hide();
        }
    });

    $save.on('click', function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const plainFormData = Object.fromEntries(formData.entries());

        plainFormData.DisabilityCondition = formData.getAll("DisabilityCondition");
        plainFormData.PreferredLearningMethod = formData.getAll("PreferredLearningMethod");
        plainFormData.DigitalTechnology = formData.getAll("DigitalTechnology");
        plainFormData.FinancialSupport = formData.getAll("FinancialSupport");

        const formDataJsonString = JSON.stringify(plainFormData);
        
        fetch('/Umbraco/Api/ApplyNow/SaveAndContinue', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: formDataJsonString
        })
        .then((res) => {
            if (res && res.status) {
                const modal = document.querySelector('#applyNowModal');
                const modalBackground = document.querySelector('#applyNowModal-bg');
                if (modal && modalBackground) {
                    modal.classList.add('show');
                    modalBackground.classList.add('show');

                    modal.addEventListener('click', () => {
                        modal.classList.remove('show');
                        modalBackground.classList.remove('show');
                    });
                    modalBackground.addEventListener('click', () => {
                        modal.classList.remove('show');
                        modalBackground.classList.remove('show');
                    });

                }
            }
            res.json();
        });

    });
    
    //$submit.on('click', function (e) {
    //    e.preventDefault();

    //    const currentTab = tabs[window.currentTab];
    //    const currentTabInputs = currentTab.querySelectorAll('input,textarea,select');

    //    if (currentTabInputs.length) {
    //        window.hasInvalidValue = false;
    //        for (let i = 0; i < currentTabInputs.length; i += 1) {
    //            validateField(currentTabInputs[i], false);
    //        }
    //    }
    //    if (window.hasInvalidValue) {
    //        const currentTabErrors = currentTab.querySelectorAll('input.input-validation-error, select.input-validation-error, textarea.input-validation-error');
    //        if (currentTabErrors.length) {
    //            currentTabErrors[0].parentElement.scrollIntoView({
    //                behavior: 'smooth',
    //                block: 'center'
    //            });
    //        }
    //    } else {
    //        $form.submit();
    //    }
    //});


    // Submit Listener
    $form.on('submit', function (e) {
        e.preventDefault();

        const currentTab = tabs[window.currentTab];
        const currentTabInputs = currentTab.querySelectorAll('input,textarea,select');

        if (currentTabInputs.length) {
            window.hasInvalidValue = false;
            for (let i = 0; i < currentTabInputs.length; i += 1) {
                validateField(currentTabInputs[i]);
            }
        }

        if (window.hasInvalidValue) {
            const currentTabErrors = currentTab.querySelectorAll('input.input-validation-error, select.input-validation-error, textarea.input-validation-error');
            if (currentTabErrors.length) {
                currentTabErrors[0].parentElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        } else {
            if($('input[name=Campus]:checked').length < 1) {
                $('#campus-not-sure').prop('checked', true);
            }

            var day = $dobDay.val();
            var month = $dobMonth.val();
            var year = $dobYear.val();

            $form[0].DateOfBirth.value = year + '-' + month + '-' + day;

            // Not used anymore?
            // if ($whatAreYouInterested.prop('checked')) {
            //     $form[0].Course.value = courseList.selectedCourseCode;
            // }

            // console.warn('apply now form sent.');
            // e.preventDefault();
            // return;

            gtag && gtag('event', 'Successfully submit', {
                event_category: 'Apply Now Form',
                event_label: 'Submit',
                transport_type: 'beacon'
            });
            form.submit();
        }
    });

    $back.hide();
    $submit.hide();
    initFields();

    setTimeout(() => {
        window.initAutocomplete = initAutocomplete;
        window.initAutocomplete();
    }, 2500);
});
